import React, { useState } from "react";
import './DIPredavacComponent.scss';

type PredavacData = {
    title: string;
    image: string;
    paragraphs: string[];
}

type Props = {
    data: PredavacData;
}

const DIPredavacComponent: React.FC<Props> = ({data}) => {
    // const [expnanded, setExpanded] = useState(false);

    // const handleExpansion = () => {
    //     setExpanded(!expnanded);
    // }

    return (
        <div className="one-predavac-container">
            <div className="title-container mobile">
                <h2>{data.title}</h2>
            </div>
            <div className="predavac-row-container">
                <div className="image-credits-container-predavac">

                    <img src={data.image} alt="Slika predavača"/>
                    
                </div>
                <div className={"content-container-predavac"}>
                    <div className="title-container desktop">
                        <h2>{data.title}</h2>
                    </div>
                    <div>
                    {data.paragraphs.map((paragraph, i) => (
                        <p className="content-p-predavac" key={i}>{paragraph}</p>
                    ))}
                    </div>
                </div>
            </div>
            {/* <div className="read-more-btn-container">
                <button className="read-more-button" onClick={handleExpansion}>{!expnanded ? 'Više' : 'Manje'}</button>
            </div> */}
        </div>
    )
}

export default DIPredavacComponent;